import { useSyncExternalStore } from "react";
import { AdminThemeT, getAdminTheme, subscribeToAdminTheme } from "../utils/adminTheme";

/** The admin theme as held in `utils/adminTheme.ts`, re-rendering when it settles or flips. */
export const useAdminTheme = (): AdminThemeT => useSyncExternalStore(subscribeToAdminTheme, getAdminTheme);
